import store from '@/store';
import Base from '@/modules/snow/components/ModuleBase';
import ProjectBase from '@/modules/snow/components/ProjectBase';
import Overview from '@/modules/snow/views/Overview';
import ActionTracker from '@/modules/projects/views/ActionTracker';
import ProjectInvoices from '@/modules/projects/views/ProjectInvoices';
import ProjectWOs from '@/modules/projects/views/ProjectWOs';
import Dashboard from '@/modules/snow/views/Dashboard';
import SnowProjectReport from '@/modules/snow/views/reports/SnowProjectReport';
import TimesheetDetails from '@/modules/projects/views/timesheetDetails/TimesheetDetails';
import ProjectEstimates from '@/modules/irrigation/components/ProjectEstimates';
import SnowCrewVisits from '@/modules/projects/views/ProjectCrewVisits';

const routes = [
  {
    path: '/snow/',
    component: Base,
    meta: { appKey: 'snowprojects' },
    children: [
      {
        path: 'dashboard',
        component: Dashboard,
        name: 'SnowDashboard',
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        },
      },
      {
        path: 'project-report',
        component: SnowProjectReport,
        name: 'SnowProjectReport',
        beforeEnter: (to, from, next) => {
          store.dispatch('clearSubnav')
          next()
        },
      },
      {
        path: 'details/:id/',
        component: ProjectBase,
        children: [
          {
            path: 'overview',
            name: 'SnowOverview',
            component: Overview
          },
          {
            path: 'invoices',
            name: 'ProjectInvoices',
            component: ProjectInvoices
          },
          {
            path: 'work-orders',
            name: 'ProjectWOs',
            component: ProjectWOs
          },
          {
            path: 'crew-visits',
            component: SnowCrewVisits,
            name: 'SnowCrewVisits',
          },
          {
            path: 'project-estimates',
            component: ProjectEstimates,
            name: 'SnowEstimates'
          },
          {
            path: 'action-tracker',
            name: 'SnowActionTracker',
            component: ActionTracker
          },
          {
            path: 'timesheet-details',
            component: TimesheetDetails,
            name: 'SnowTimesheetDetails',
          }
        ]
      }
    ]
  }
]

export default routes
